import { Screen } from 'components/Screen/Screen.component'
import React, { useEffect, useState } from 'react'
import {
  CANNABIS_TYPE,
  GROG_DIARY,
  OPIOIDS_TYPE,
  TOBACCO_TYPE,
  BENZOS_TYPE,
  METH_TYPE,
  HEROIN_TYPE,
  OTHER_TYPE
} from 'shared/constants/SurveyFields.d'
import {
  outroGlobalShortcodesRender,
  shortcodesRender
} from 'shared/utils/shortcodesRender/shortcodesRender'
import { EffectsCarouselScreenPropsModel } from './EffectsCarouselScreen.model'
import styles from './EffectsCarouselScreen.module.scss'
import { SurveyState } from 'store/type'
import { connect } from 'react-redux'
import { GLOBAL_SHORTCODES } from 'shared/constants/shortcodes/Shortcodes.d'
import { CircleChoiceOptionModel } from 'components/CircleChoice/CircleChoice.model'
import { UsingKeys } from 'shared/constants/Constants.d'
import { CircleChoice } from 'components/CircleChoice/CircleChoice.component'
import { matchCondition } from 'shared/utils/matchCondition/matchCondition'

export const EffectsCarouselScreenComponent: React.FC<
  EffectsCarouselScreenPropsModel
> = (props) => {
  const {
    currentScreenId,
    theme,
    headerProps,
    screenData,
    footerProps,
    shortcodes,
    states
  } = props

  const { title, subtitle } = screenData

  const [types, setTypes] = useState<string[]>([])
  const [circles, setCircles] = useState<CircleChoiceOptionModel[]>([])
  const [value, setValue] = useState<string>()

  const { getNextScreenId } = matchCondition()

  const handleFooterProps = () => {
    const updatedFooterProps = { ...footerProps }

    if (!value) {
      updatedFooterProps.invalid = true
    } else {
      updatedFooterProps.invalid = false
    }

    if (updatedFooterProps.nextScreenId) {
      updatedFooterProps.nextScreenId = getNextScreenId(
        undefined,
        footerProps.conditions,
        footerProps.nextScreenId
      )
    }

    return updatedFooterProps
  }

  useEffect(() => {
    const includeTypes = []
    let includeCircles: CircleChoiceOptionModel[] = []

    if (states) {
      // has grog
      if (states[GROG_DIARY]) {
        includeTypes.push('grog')
      }
      // has tobacco
      if (states[TOBACCO_TYPE]) {
        includeTypes.push('tobacco')
      }
      // has cannabis
      if (states[CANNABIS_TYPE]) {
        includeTypes.push('cannabis')
      }
      // has meth
      if (states[METH_TYPE]) {
        includeTypes.push('meth')
      }
      // has heroin
      if (states[HEROIN_TYPE]) {
        includeTypes.push('heroin')
      }
      // has opioid
      if (states[OPIOIDS_TYPE[1]]) {
        includeTypes.push('opioid')
      }
      // has benzos
      if (states[BENZOS_TYPE]) {
        includeTypes.push('benzos')
      }
      // has other
      if (states[OTHER_TYPE]) {
        includeTypes.push('other')
      }
      setTypes(includeTypes)

      // set Circles
      includeTypes.forEach((type) => {
        includeCircles = includeCircles.concat(
          screenData[type as keyof typeof UsingKeys]
        )
      })
      setCircles(includeCircles)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={`drug-app-screen ${styles.effectscarouselscreen}`}>
      <Screen
        currentScreenId={currentScreenId}
        theme={theme}
        headerProps={headerProps}
        footerProps={handleFooterProps()}
      >
        <div className={styles['effectscarouselscreen-content']}>
          <div className={styles['effectscarouselscreen-titles']}>
            {title && (
              <h1
                className="screen-titles--title"
                dangerouslySetInnerHTML={{
                  __html:
                    shortcodesRender(
                      shortcodes,
                      outroGlobalShortcodesRender(
                        GLOBAL_SHORTCODES.OUTRO_USING_TYPES,
                        title,
                        types
                      )
                    ) ||
                    outroGlobalShortcodesRender(
                      GLOBAL_SHORTCODES.OUTRO_USING_TYPES,
                      title,
                      types
                    )
                }}
              />
            )}
            {subtitle && (
              <p
                className="screen-titles--subtitle"
                dangerouslySetInnerHTML={{ __html: subtitle }}
              />
            )}
          </div>
          <div className={styles['effectscarouselscreen-amount']}>
            {
              <CircleChoice
                options={circles}
                setValue={(v) => setValue(v)}
                playAudio={footerProps?.playAudio}
              />
            }
          </div>
        </div>
      </Screen>
    </div>
  )
}

const mapStateToProps = (state: SurveyState) => ({
  states: state.surveyData
})

export const EffectsCarouselScreen = connect(mapStateToProps)(
  EffectsCarouselScreenComponent
)
